/**
 * Class with utility methods for formatting values
 */
export class Formatter {
  /**
   * Attempts to convert a string to an integer
   * @param {string} value 
   * @returns 
   */
  static integer(value) {
    let val = parseInt(Formatter.number(value), 10);
    return isNaN(val) ? 0 : val;
  }
  /**
   * Attempts to convert a value into a number
   * 
   * @param {string} value 
   * @returns 
   */


  static number(value) {
    value += "";
    value = value.replace(/,/g, "");
    value = value.replace(/[kK]+/, 'k');
    value = value.replace(/[kK]/, "000");
    return parseFloat(value) || 0;
  }
  /**
   * Adds commas to a number
   * e.g. 1000 -> 1,000
   * 
   * @param {number} num 
   * @returns 
   */


  static commas(num) {
    let parts = num.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  /**
   * Converts a number to a human-readable price format
   * e.g. 1000 -> $1,000, $1,000.00, etc
   * 
   * @param {number} value 
   * @param {number} fractionDigits The number of digits to appear after the decimal point (0-20).
   * @returns 
   */


  static price(value, fractionDigits = 0) {
    let pre = '$';

    if (value < 0) {
      pre = '-' + pre;
    }

    return pre + Formatter.commas(Math.abs(value).toFixed(fractionDigits));
  }

}
//# sourceMappingURL=Formatter.js.map